import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import '@/common/css/output.scss'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

Vue.use(ViewUI)

Vue.config.productionTip = false

let newVue = new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})
export default newVue


// WEBPACK FOOTER //
// ./src/main.js